import React, { PureComponent } from "react";

export default class HeaderSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
    };
  }

  componentDidMount() {   
  }

  componentWillMount() {
  }

  onkeydown = (e) => {
    if (e.keyCode === 13) {
      this.handleClick(e);
    }
  }

  handleClick = () => {
    if (this.refs.search.value != '') {
      this.props.history.replace("/entrance/TextSearch?searchMessage=" + this.refs.search.value)
    }
   
  }

  render() {
    let { noShowSearch, noShowSwitchover } = this.state;
    return (
      <div className="search-box">
          <div className="header_right_search">
            <input ref="search" type="text" placeholder="请输入关键字查询"/>
            <a href="/entrance/searchResult" className="header_logo_search_btn">搜索</a>
          </div>
            <div className="yinzhang"></div>
      </div>
       

    );
  }
}
